var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTooltip",
    _vm._b(
      {
        staticClass: "automation-landing-card__tooltip",
        attrs: { disabled: !_vm.showTooltip }
      },
      "CompassTooltip",
      _vm.tooltipProps,
      false
    ),
    [
      _c(
        "div",
        {
          staticClass: "automation-landing-card",
          class: { "automation-landing-card--disabled": _vm.disabled },
          attrs: { "aria-disabled": _vm.disabled, "data-bot": _vm.dataBot },
          on: { click: _vm.handleClick }
        },
        [
          _c("CompassIcon", { attrs: { icon: _vm.icon, size: "extra-large" } }),
          _vm._v(" "),
          _c("div", { staticClass: "automation-landing-card-content" }, [
            _c(
              "div",
              { staticClass: "automation-landing-card__header" },
              [
                _c(
                  "p",
                  {
                    staticClass:
                      "automation-landing-card__title typographies-paragraph-large-semibold"
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.title) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.soon
                  ? _c("CompassFlag", { attrs: { label: "Bientôt" } })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "automation-landing-card__caption typographies-paragraph-medium-regular"
              },
              [
                _vm._v(
                  "\n                " + _vm._s(_vm.caption) + "\n            "
                )
              ]
            )
          ]),
          _vm._v(" "),
          !_vm.disabled
            ? _c("CompassIconButton", {
                staticClass: "automation-landing-card__arrow-button",
                attrs: { icon: "arrow-right" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.handleClick($event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }